import axios from 'axios'
import store from '@/store'
import { bus } from '@/main'
import Router from '@/router'

const noSession = [401, 419]

const client = axios.create({
  baseURL: `${process.env.VUE_APP_API}/api`,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json'
  },
})

client.interceptors.request.use(req => {
  bus.$emit('startLoading')
  return req
}, e => {
  bus.$emit('stopLoading')
  bus.$emit('apiError', e.response)
  return Promise.reject(e)
})

client.interceptors.response.use(res => {
  bus.$emit('stopLoading')
  return res
}, e => {
  if (noSession.includes(e.response.status)) {
    store.commit('auth/UNSET_AUTH')
    Router.push({ name: 'sign-in' })
   } else {
    bus.$emit('stopLoading')
    bus.$emit('apiError', e.response)
    return Promise.reject(e)
  }
})

export default client
